<template>
  <Listing />
</template>
<script>
import Listing from './components/Listing'
export default ({
  name: 'BMW',
  components: {
    Listing,
  },
  data () {
    return {
      sitetitle: 'BMW',
    }
  },
})
</script>
<style>
#app {
  font-family: 'BMWTypeWebProTin', Arial !important;
  font-size: 16px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #000000;
  overflow: hidden;
}

#nav {
  padding: 30px;
  width: 100%;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
